let map;

function initMap() {
  // Define custom map style
  const customMapStyle = [
    { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
    { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
    { featureType: "poi", stylers: [{ visibility: "off" }] },
    { featureType: "road", stylers: [{ color: "#ffffff" }] },
    { featureType: "road.highway", stylers: [{ color: "#dadada" }] },
    { featureType: "water", stylers: [{ color: "#c9c9c9" }] },
  ];

  // Initialize map
  map = new google.maps.Map(document.getElementById("map"), {
    center: { lat: -33.8688, lng: 151.2093 },
    zoom: 10,
    styles: customMapStyle,
  });

  // ✅ Store locations
  const locations = [
    {
      lat: -33.8916,
      lng: 151.2762,
      name: "Nourish Organics Bondi- Premier Stockist ⭐️",
      address: "Bondi, NSW",
      phone: "(02) 1234 5678",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.8916,151.2762",
    },
    {
      lat: -34.0334,
      lng: 151.0807,
      name: "Nourish Organics Gymea- Premier Stockist ⭐️",
      address: "Gymea, NSW",
      phone: "(02) 8765 4321",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-34.0334,151.0807",
    },
    {
      lat: -34.0527,
      lng: 151.1524,
      name: "Nourish Organic Cronulla- Premier Stockist ⭐️",
      address: "Cronulla, NSW",
      phone: "(02) 5678 1234",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-34.0527,151.1524",
    },
    {
      lat: -37.8136,
      lng: 144.9631,
      name: "Jeffries Providores Victoria",
      address: "Victoria",
      phone: "(03) 9876 5432",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-37.8136,144.9631",
    },
    {
      lat: -37.8595,
      lng: 145.0272,
      name: "Wholefoods Malvern",
      address: "72 Glenferrie Rd, Malvern VIC 3144",
      phone: "(03) 9123 4567",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-37.8595,145.0272",
    },
    {
      lat: -33.912,
      lng: 151.2395,
      name: "QE Randwick",
      address: "1/62 Frenchmans Rd, Randwick NSW 2031",
      phone: "(02) 9988 7766",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.9120,151.2395",
    },
    {
      lat: -33.8261,
      lng: 151.2007,
      name: "QE Crows Nest",
      address: "53 Willoughby Rd, Crows Nest NSW 2065",
      phone: "(02) 8877 6655",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.8261,151.2007",
    },
    {
      lat: -33.898,
      lng: 151.1808,
      name: "QE Newtown",
      address: "408 King St, Newtown NSW 2042",
      phone: "(02) 7766 5544",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.8980,151.1808",
    },
    {
      lat: -33.8574,
      lng: 151.181,
      name: "QE Balmain",
      address: "355 Darling St, Balmain NSW 2041",
      phone: "(02) 6655 4433",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.8574,151.1810",
    },
    {
      lat: -33.9004,
      lng: 151.2495,
      name: "QE Waverley",
      address: "235 Bronte Road, Waverley, NSW 2024",
      phone: "(02) 5544 3322",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.9004,151.2495",
    },
    {
      lat: -31.9944,
      lng: 115.7631,
      name: "Boatshed Markets",
      address: "40 Jarrad St, Cottesloe WA 6011",
      phone: "(08) 9284 5176",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-31.9944,115.7631",
    },
    {
      lat: -35.2551,
      lng: 149.1447,
      name: "IGA Ainslie",
      address: "9–11 Edgar St, Ainslie, Canberra ACT",
      phone: "(02) 6248 5777",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-35.2551,149.1447",
    },
    {
      lat: -37.8383,
      lng: 144.9923,
      name: "LaManna and Sons South Yarra",
      address: "670 Chapel St, South Yarra VIC 3141",
      phone: "(03) 9804 7631",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-37.8383,144.9923",
    },
    {
      lat: -37.81901,
      lng: 145.15326,
      name: "Jefferies | Your Local Provedore",
      address: "B1/162 Whitehorse Rd, Blackburn VIC 3130",
      phone: "(03) 9121 3366",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-37.81901,145.15326",
    },
    {
      lat: -33.75444,
      lng: 151.28528,
      name: "IGA Local Grocer Dee Why Beach",
      address: "13 The Strand, Dee Why NSW 2099",
      phone: "(02) 8484 0320",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.75444,151.28528",
    },
    {
      lat: -33.86552,
      lng: 151.16156,
      name: "Maloneys Grocer",
      address: "731 Darling St, Rozelle NSW 2039, Australia",
      phone: "(02) 7205 4433",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.86552,151.16156",
    },
    {
      lat: -37.80041,
      lng: 144.97869,
      name: "IGA Fitzroy",
      address: "424 Brunswick St, Fitzroy VIC 3065, Australia",
      phone: "(03) 9598 1953",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-37.80041,144.97869",
    },
    {
      lat: -34.0650134,
      lng: 151.0138225,
      name: "Go Vita Engadine",
      address: "1052 Old Princess Highway, Engadine NSW 2233",
      phone: "02 8359 1985",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-34.0650134,151.0138225",
    },
    {
      lat: -41.18051,
      lng: 146.35004,
      name: "Hill Street Grocer Devonport",
      address: "48-54 Oldaker Street, Devonport TAS 7310",
      phone: "(03) 6127 5355",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-41.18051,146.35004",
    },
    {
      lat: -42.90266,
      lng: 147.32471,
      name: "Hill Street Grocer Sandy Bay",
      address: "Corner of TT Flynn Street & 2 Churchill Avenue, Sandy Bay TAS 7005",
      phone: "(03) 6240 4881",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-42.90266,147.32471",
    },
    {
      lat: -42.87515,
      lng: 147.30972,
      name: "Hill Street Grocer West Hobart",
      address: "70 Arthur Street, West Hobart TAS 7000",
      phone: "(03) 6234 6849",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-42.87515,147.30972",
    },
    {
      lat: -41.59429,
      lng: 147.11958,
      name: "Hill Street Grocer Longford",
      address: "7a Wellington Street, Longford TAS 7301",
      phone: "(03) 6391 1409",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-41.59429,147.11958",
    },
    {
      lat: -41.24387,
      lng: 146.41508,
      name: "Hill Street Grocer Latrobe",
      address: "108-114 Gilbert Street, Latrobe TAS 7307",
      phone: "(03) 6426 5000",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-41.24387,146.41508",
    },
    {
      lat: -37.72763,
      lng: 144.89735,
      name: "La Manna – Essendon Fields",
      address: "10 English St, Essendon Fields VIC 3041",
      phone: "(03) 9933 1111",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-37.72763,144.89735",
    },
    {
      lat: -38.3754,
      lng: 144.81762,
      name: "General Beach Store",
      address: "414 Tasman Dr, Rye VIC 3941",
      phone: "(03) 5985 3741",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-38.37540,144.81762",
    },
    {
      lat: -35.26443,
      lng: 149.04941,
      name: "Cook Grocer",
      address: "27 Cook Pl, Cook ACT 2614",
      phone: "(02) 6251 7948",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-35.26443,149.04941",
    },
    {
      lat: -38.04079,
      lng: 145.36909,
      name: "Green Soul Organics",
      address: "Shop 2/46-50 Old Princes Hwy, Beaconsfield VIC 3807",
      phone: "(03) 9769 8979",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-38.04079,145.36909",
    },
    {
      lat: -27.46869,
      lng: 153.06137,
      name: "Hawthorne Garage",
      address: "285 Hawthorne Rd, Hawthorne QLD 4171",
      phone: "(07) 3899 5511",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-27.46869,153.06137",
    },
    {
      lat: -28.86522,
      lng: 153.55592,
      name: "Wattlebee Baby",
      address: "Shop 8, Ballina Central, 44 Bangalow Rd, Ballina NSW 2478",
      phone: "0421 061 002",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-28.86522,153.55592",
    },
    {
      lat: -33.85379,
      lng: 151.15686,
      name: "Harris Farm – Drummoyne",
      address: "121-125 Victoria Rd, Drummoyne NSW 2047",
      phone: "(02) 9181 3620",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.85379,151.15686",
    },
    {
      lat: -33.82518,
      lng: 151.23968,
      name: "Harris Farm – Mosman",
      address: "Shop 12, Bridgepoint Shopping Centre, 1-3 Brady St, Mosman NSW 2088",
      phone: "(02) 9969 4211",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.82518,151.23968",
    },
    {
      lat: -33.79594,
      lng: 151.28717,
      name: "Harris Farm – Manly",
      address: "245-259 Pittwater Rd, Manly NSW 2095",
      phone: "(02) 9977 3133",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.79594,151.28717",
    },
    // {
    //   lat: -33.89274,
    //   lng: 151.27463,
    //   name: "Harris Farm – Bondi Beach",
    //   address: "61-79 Hall Street, Bondi Beach NSW 2026",
    //   phone: "(02) 9385 5800",
    //   directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.89274,151.27463",
    // },
    {
      lat: -33.8613549,
      lng: 151.1654937,
      name: "Fruitologist, Rozelle",
      address: "Shop 2c/2 Nagurra Pl, Rozelle NSW 2039, Australia",
      phone: "(02) 9555 1612",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.8613549,151.1654937",
    },
    // ✅ The Memo locations
    {
      lat: -37.85548,
      lng: 145.02262,
      name: "The Memo, Armadale",
      address: "1155 High Street, Armadale VIC 3143, Australia",
      phone: "(03) 9599 2712",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-37.85548,145.02262",
    },
    {
      lat: -37.80652,
      lng: 144.98392,
      name: "The Memo, Fitzroy",
      address: "188 Gertrude Street, Fitzroy VIC 3065, Australia",
      phone: "(03) 9008 4579",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-37.80652,144.98392",
    },
    {
      lat: -37.77191,
      lng: 144.88856,
      name: "The Memo, Highpoint",
      address:
        "Shop L03-3089, Highpoint Shopping Centre, Rosamond Road, Maribyrnong VIC 3032, Australia",
      phone: "(03) 9008 4511",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-37.77191,144.88856",
    },
    {
      lat: -33.8922,
      lng: 151.2514,
      name: "The Memo, Bondi Junction",
      address: "71 Ebley Street, Bondi Junction NSW 2022, Australia",
      phone: "(02) 9137 6300",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.89220,151.25140",
    },
    {
      lat: -26.4014053,
      lng: 153.066544,
      name: "Organika Noosaville",
      address:
        "Shop 2/3 Gibson Rd, Noosaville QLD 4566, Australia",
      phone: "+61 7 5442 4973",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-26.4014053,153.066544",
    },
    {
      lat: -34.034533,
      lng: 151.100196,
      name: "Harris Farm Markets - Miranda",
      address: "Shop 1171-75, Westfield Miranda, 600 Kingsway, Miranda NSW 2228, Australia",
      phone: "(02) 9394 3250",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-34.034533,151.100196",
    },
    {
      lat: -32.935312,
      lng: 151.768703,
      name: "Harris Farm Markets - Cooks Hill (Newcastle)",
      address: "227 Darby Street, Cooks Hill NSW 2300, Australia",
      phone: "(02) 4036 3345",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-32.935312,151.768703",
    },
    {
      lat: -33.7277474,
      lng: 151.1419546,
      name: "Turramurra Wholefoods",
      address: "20 Princes St, Turramurra NSW 2074, Australia",
      phone: "(02) 9144 5092",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.7277474,151.1419546",
    },
    {
      lat: -33.899046,
      lng: 151.1727416,
      name: "Taste Organic Enmore",
      address: "164 Enmore Rd, Enmore NSW 2042, Australia",
      phone: "(02) 8541 3899",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.899046,151.1727416",
    },
    {
      lat: -38.4536,
      lng: 145.2393,
      name: "The Corner Dispensary",
      address: "74A Chapel St, Cowes VIC 3922, Australia",
      phone: "(03) 5952 3398", 
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-38.4536,145.2393",
    },
    {
      lat: -19.2823,
      lng: 146.8006,
      name: "Let's Talk Birth - Rising Sun Plaza",
      address: "Shop 11/260 Charters Towers Rd, Hermit Park QLD 4812, Australia",
      phone: "(04) 18 866 236",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-19.2823,146.8006",
    },
    {
      lat: -33.6837,
      lng: 150.9167,
      name: "Harris Farm Markets Dural",
      address: "7-9 Kenthurst Rd, Dural NSW 2158, Australia",
      phone: "(02) 9394 3210",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.6837,150.9167",
    },
    {
      lat: -33.9120,
      lng: 151.1565,
      name: "Harris Farm Markets Marrickville",
      address: "186 Victoria Rd, Marrickville NSW 2204, Australia",
      phone: "(02) 9394 3245",
      directionsLink: "https://www.google.com/maps/dir/?api=1&destination=-33.9120,151.1565",
    }
    ];

    

  // Add markers and list items for each location
  const storeList = document.getElementById("store-locations");

  // Keep references so the search bar can filter both list + markers
  const storeEntries = [];

  locations.forEach((location) => {
    const marker = new google.maps.Marker({
      position: { lat: location.lat, lng: location.lng },
      map: map,
      title: location.name,
    });

    // ✅ better tel formatting
    const telClean = location.phone ? location.phone.replace(/[^\d+]/g, "") : "";

    const infoWindowContent = `
      <div style="font-family: Arial, sans-serif; color: #333;">
        <h4 style="margin: 0; color: red;">${location.name}</h4>
        <p style="margin: 5px 0;">${location.address}</p>
        ${
          location.phone
            ? `<p style="margin: 5px 0;">Phone: <a href="tel:${telClean}" style="color: #007BFF;">${location.phone}</a></p>`
            : ""
        }
        <p style="margin: 5px 0;">
          <a href="${location.directionsLink}" target="_blank" style="color: #007BFF;">Directions</a> | 
          <a href="javascript:void(0);" onclick="zoomToLocation(${location.lat}, ${location.lng})" style="color: #007BFF;">Zoom here</a>
        </p>
      </div>
    `;

    const infoWindow = new google.maps.InfoWindow({
      content: infoWindowContent,
    });

    marker.addListener("click", () => {
      infoWindow.open(map, marker);
    });

    // Sidebar list (only if element exists)
    if (storeList) {
      const listItem = document.createElement("li");
      listItem.innerHTML = `<strong>${location.name}</strong><br>${location.address}`;
      listItem.style.cursor = "pointer";
      listItem.style.marginBottom = "10px";

      listItem.addEventListener("click", () => {
        map.setCenter(marker.getPosition());
        map.setZoom(14);
        infoWindow.open(map, marker);
      });

      storeList.appendChild(listItem);

      storeEntries.push({
        listItem,
        marker,
        searchText: `${location.name} ${location.address}`.toLowerCase(),
      });
    }
  });

  // Wire up the search bar to filter stores by name / suburb / postcode
  const searchInput = document.getElementById("store-search");
  const emptyMessage = document.getElementById("store-search-empty");

  if (searchInput) {
    searchInput.addEventListener("input", () => {
      const query = searchInput.value.trim().toLowerCase();
      let visibleCount = 0;

      storeEntries.forEach((entry) => {
        const isMatch = query === "" || entry.searchText.includes(query);
        entry.listItem.style.display = isMatch ? "" : "none";
        entry.marker.setVisible(isMatch);
        if (isMatch) visibleCount++;
      });

      if (emptyMessage) {
        emptyMessage.hidden = visibleCount !== 0;
      }
    });
  }
}

// Function to zoom into a specific location
function zoomToLocation(lat, lng) {
  map.setCenter({ lat: lat, lng: lng });
  map.setZoom(15);
}
